$(function () {
    if (!$('.scratcher-related-games').length) return;

    bindScratcherRelatedGameTileEvents();
});

function bindScratcherRelatedGameTileEvents() {
    var $tiles = $('.scratcher-related-games .scratcher-tile');

    //Set initial tile-left background
    $tiles.each(function () {
        var $tile = $(this);
        var imageUrl = $tile.data('image-url');
        if (imageUrl) {
            initialBackground($tile, imageUrl);
        }
    });

    $tiles.on('mouseenter', function () {
        var $tile = $(this);
        var imageUrl = $tile.data('image-url');
        if (imageUrl) {
            hoverBackground($tile, imageUrl);
        }
    });
    $tiles.on('mouseleave', function () {
        var $tile = $(this);
        var imageUrl = $tile.data('image-url');
        if (imageUrl) {
            initialBackground($tile, imageUrl);
        }
    });

    function initialBackground($tile, imageUrl) {
        var $tileLeft = $tile.find('.tile-left');
        $tileLeft.css('background', '');
        var defaultBackgroundColor = $tileLeft.css('background-color');
        $tileLeft.css({
            "background": "linear-gradient(0deg, " + defaultBackgroundColor + ", " + defaultBackgroundColor + "), url(" + imageUrl + ")",
            "background-size": "cover"
        });
        $tileLeft.children().css("color", "");
    }
    function hoverBackground($tile, imageUrl) {
        var $tileLeft = $tile.find('.tile-left');
        $tileLeft.css({
            "background": "linear-gradient(0deg, transparent, transparent), url(" + imageUrl + ")",
            "background-size": "cover"
        });
        $tileLeft.children().css("color", "transparent");
    }
}



// WEBPACK FOOTER //
// ./features/related-games/scratcher-related-games/scratcher-related-games.js